<div class="page-not-found h-100 w-100">
    <div class="container">
        <div class="d-flex flex-column align-items-center">
            <div class="p-1">
                <img src="assets/images/common/icons_usp/ic_403.svg" class="img-fluid" alt="page-not-found">

            </div>
            <div class="page-not-found-text mt-2">
                <span [innerHtml]="staticText?.error_pages?.page_not_found?.page_not_found_text"></span>
            </div>
            <div class="p-1 pt-2 pb-2 page-not-found-para ">
                <p class="mt-2" [innerHtml]="staticText?.error_pages?.page_not_found?.page_not_found_para"></p>
            </div>
            <div class=" pb-4 mt-1 text-captialize">
                <button mat-raised-button class="btn_login_user" (click)="goToHomePage()"
                    [innerHtml]="staticText?.error_pages?.access_forbidden?.back_btn">
                </button>
            </div>
        </div>
    </div>
</div>